import { createSlice } from "@reduxjs/toolkit";
import { fetchDeals, createDeal } from "./dealThunk";

const initialState = {
  list: [],
  loading: false,
  createLoading: false,
};

const dealSlice = createSlice({
  name: "deals",
  initialState,
  reducers: {
    incrementActivityCount: (state, action) => {
      const deal = state.list.find(d => d.deal_id === action.payload);
      if (deal) {
        deal.activity_count = (deal.activity_count || 0) + 1;
        deal.last_activity_at = new Date().toISOString();
      }
    },
    updateStageLocal: (state, action) => {
      const { deal_id, stage } = action.payload;
      const deal = state.list.find(d => d.deal_id === deal_id);
      if (deal) {
        deal.stage = stage;
      }
    },

    updateDealLocal: (state, action) => {
      const { deal_id, ...rest } = action.payload;
      const deal = state.list.find(d => d.deal_id === deal_id);
      if (deal) {
        Object.assign(deal, rest);
      }
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeals.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDeals.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchDeals.rejected, (state) => {
        state.loading = false;
      })

      .addCase(createDeal.pending, (state) => {
        state.createLoading = true;
      })
      .addCase(createDeal.fulfilled, (state) => {
        state.createLoading = false;
      })
      .addCase(createDeal.rejected, (state) => {
        state.createLoading = false;
      });
  },
});

export const { incrementActivityCount, updateStageLocal, updateDealLocal } = dealSlice.actions;

export default dealSlice.reducer;